import { PayloadAction } from '@reduxjs/toolkit';
import { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';
import { call, put, takeLatest } from 'redux-saga/effects';
import { EdsDefinitionSections } from '@/features/eds/enums/EdsDefinitionSections';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import EdsAdapterService from '@/features/eds/services/EdsAdapterService/EdsAdapterService';
import EdsDebugService from '@/features/eds/services/EdsDebugService/EdsDebugService';
import HttpService from '@/services/HttpService/HttpService';
import {
  getTransactionDetails,
  getTransactionDetailsError,
  getTransactionDetailsSuccess,
  startLoadingTransactionDetails,
} from '../store/transactionSlice';

function* getTransactionDetailsSaga(
  action: PayloadAction<{
    transactionId: string | number;
  }>,
) {
  try {
    if (!action.payload.transactionId) return;

    yield put(startLoadingTransactionDetails());

    const { data } = yield call(
      HttpService.get,
      `/v2/${EdsEntityCodes.Transaction}/${action.payload.transactionId}?includeEntities=Payment.PaymentSchedule.PaymentSplits.PaymentMethod.Address,Payment.Payee.Party.Person,Payment.Payee.Party.Business,PaymentMethod.Address`,
      {},
      {
        baseURL: import.meta.env.VITE_API_URL_EDS,
      },
    );

    const normalizedResponse: NormalizedV2Response = yield call(EdsAdapterService.normalize, data, {
      section: EdsDefinitionSections.SidePanel,
    });

    if (data && normalizedResponse) {
      EdsDebugService.logResponse(EdsEntityCodes.Transactions, {
        rawResponse: data,
        normalizedResponse,
        includedEntitiesRecord: normalizedResponse.entities,
      });

      yield put(getTransactionDetailsSuccess(normalizedResponse));
    }
  } catch (error) {
    yield put(getTransactionDetailsError());
    console.error(error);
  }
}

export function* transactionDetailsWatcher() {
  yield takeLatest([getTransactionDetails.type], getTransactionDetailsSaga);
}
